import React, { useEffect, useState } from "react";
import "./Fasting.css";
import { Link } from "react-router-dom";

const Fasting = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");

    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <>
      {/* <div>
                <div class="wrapper" id="cover">
                    <img
                        src={require("../../../Assets/images/cover-fasting.jpg")}
                        class="prx"
                        style={{ height: "250px", width: "100%" }}
                    />
                    <h1>Prayer</h1>
                </div>
            </div> */}
      <section style={{ marginBottom: "60px" }}>
        <div class="fasting-bloc">
          <div class="fasting-fbloc">
            <h1>
              {rtl
                ? `فضائل الصيام (الصوم معناه في حياتنا)`
                : fr
                ? "JEÛNE (SAWM)"
                : `Fasting (sawm)`}{" "}
            </h1>
            <ul>
              <li>
                {rtl
                  ? `نصلي معا، نفطر معا، الإسلام مجتمع.`
                  : fr
                  ? "Nous prions ensemble, nous rompons notre jeûne ensemble, l'islam est une communauté."
                  : `We pray together, we break our fast together,
                                Islam is community.`}
              </li>
              <li>
                {rtl
                  ? `يهدف فعل الصيام إلى تذكير المسلمين بالفقراء و المحتاجين وتعزيز الحاجة إلى الشكر. هذا هو السبب في أن مكة
والمدينة القابضة تنشئ مؤسسة خيرية للتبرع ومساعدة الفقراء.`
                  : fr
                  ? `L'acte de jeûne a pour but de rappeler aux musulmans l'existence des moins fortunés et de
                  renforcer le besoin d'être reconnaissant. C'est pourquoi MMH a créé une fondation de charité
                  pour faire des dons et aider les pauvres.`
                  : `The act of fasting is meant to remind Muslims of
                                the less fortunate and to reinforce the need to
                                be thankful. That’s why MMH create a charity
                                foundation to donate and to help poor people.`}
              </li>
              <li>
                {rtl
                  ? `ستقوم مكة والمدينة القابضة بإنشاء مخزن الطعام التابع للمركز الإسلامي وهو برنامج خدمة يديره متطوعون وسيخدم
المجتمع بانتظام كل رمضان.`
                  : fr
                  ? `MMH va créer la "Centre islamique pour la nourriture", un programme de service géré par des
                  bénévoles qui servira régulièrement la communauté à chaque Ramadan.`
                  : `MMH will create Islamic Center’s Food Pantry is
                                a volunteer-run service program that will
                                regularly serve the community every Ramadan.`}
              </li>
              <li>
                {rtl
                  ? `في كل رمضان، سنقوم بتوزيع الطعام على العديد من العائلات. سيصبح برنامج مخزن الطعام منارة للتنوع والوحدة
والصداقة. نرحب بالبالغين والأطفال والمجموعات بين الأديان التي ترغب في التواصل والخدمة.`
                  : fr
                  ? `Chaque Ramadan, nous distribuerons de la nourriture à de nombreuses familles. Le programme de
                  cantine (des repas gratuits) deviendra un phare pour la diversité, l'unité et l'amitié. Nous
                  accueillons les adultes, les enfants et les groupes interconfessionnels qui souhaitent se connecter
                  et servir.`
                  : `Every Ramadan, we will distribute food to many
                                families. The Food Pantry program will become a
                                beacon for diversity, unity and friendship. We
                                welcome adults, children and interfaith groups
                                wishing to connect and serve.`}
              </li>
              <li>
                {rtl
                  ? `تكاتفوا معنا لإنجاز كل هذه المشاريع لخدمة الإنسانية وجعل هذا العالم مكانا أفضل للعيش فيه. هناك العديد من فرص
التوعية المجتمعية والحوار بين الأديان والتطوع في مؤسستنا الخيرية. يرجى إعلامنا كيف تريد خدمة المجتمع عن
طريق مراسلتنا عبر البريد الإلكتروني.`
                  : fr
                  ? `Joignez vos mains aux nôtres pour accomplir tous ces projets de service à l'humanité et faire de ce
                  monde un meilleur endroit où vivre. Notre fondation de charité offre de nombreuses possibilités
                  de travail communautaire, interconfessionnel et de bénévolat. Faites-nous savoir comment vous
                  aimeriez servir la communauté en nous envoyant un courriel.`
                  : `Join hands with us to accomplish all these
                                projects of serving humanity and making this
                                world a better place to live. There are many
                                community outreach, interfaith and volunteer
                                opportunities at our charity foundation. Please
                                let us know how you’d like to serve the
                                community by emailing us.`}
              </li>
            </ul>
          </div>
          <div class="fasting-img">
            <img
              src={require("../../../Assets/images/tamer.jpg")}
              alt="fasting"
              style={{ borderRadius: "10px" }}
            />
          </div>
        </div>
        <div style={{ padding: "0 55px 55px 55px" }} id="fasting-s-b">
          <h2 style={{ fontSize: "30px" }}>
            {rtl
              ? `هل يمكن للصيام أن يغير عملك؟ حياتك؟ عالمك ؟`
              : fr
              ? "LE JEÛNE PEUT-IL CHANGER VOTRE ENTREPRISE ? VOTRE VIE ? VOTRE MONDE ?"
              : `Could Fasting Change Your Business? Your Life? Your
                        World?`}
          </h2>
          <p style={{ width: "83%" }}>
            {rtl
              ? `وفقا لتجربتي الخاصة كمؤسس ورائد أعمال ، فإن الصيام يجعلني رائد أعمال أفضل. هناك الكثير من الأسباب التي
تجعلك تصوم ، والتغيير الفسيولوجي والروحي يجعلني أفكر بشكل أعمق في عملي أيضا. يمكن أن يساعدك الصيام
على تنمية أعمالك في اقتصاد اليوم. عند ممارسة الصيام ، يبلغ الكثير من الناس عن شعورهم بمزيد من التركيز
والنشاط ومستويات أعلى من التركيز. الصيام من أجل سمعة تجارية صحية.`
              : fr
              ? `D'après ma propre expérience en tant que fondateur et entrepreneur, le jeûne fait de moi un
              meilleur entrepreneur. Il y a beaucoup de raisons pour lesquelles vous pourriez jeûner, le
              changement physiologique et spirituel me fait penser plus profondément à mes affaires aussi.
              
              Le jeûne peut éventuellement vous aider à développer votre entreprise dans l'économie
d'aujourd'hui. En pratiquant le jeûne, beaucoup de gens disent se sentir plus concentrés, plus
énergiques et plus productifs. Le jeûne pour une réputation saine en affaires.`
              : `According to my own experience as a founder and
                        entrepreneur, Fasting makes me a better entrepreneur.
                        There are plenty of reasons why you might fast,
                        physiological, and spiritual change makes me think
                        deeper about my business as well. Fasting can possibly
                        help you growing your business in today's economy. When
                        practicing fasting, many people report feeling more
                        focused, energized, and at higher levels of
                        concentration. Fasting for a Healthy Business
                        Reputation.`}
          </p>
        </div>
      </section>
      <div class="container">
        <div class="plrs-wrap text-center remove-ext5">
          <div
            class="row"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div class="col-md-3 col-sm-6 col-lg-2 plrs ">
              <Link to="/five-pillars-shahada">
                <div class="plr-box ">
                  <i class="flaticon-clicker"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `الشهادتان` : `Shahadah`}</h4>
                    <p>({rtl ? `ايمان` : fr ? "La foi" : `Faith`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 plrs">
              <Link to="/five-pillars-prayer">
                <div class="plr-box">
                  <i class="flaticon-islamic-pray"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `إقامِ الصلاةِ` : `Salah`}</h4>
                    <p>({rtl ? `صلاة` : fr ? "Prière" : `Prayer`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 plrs">
              <Link to="/five-pillars-fasting">
                <div class="plr-box">
                  <i class="flaticon-islamic-ramadan"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `صومِ رمضانَ` : `Sawm`}</h4>
                    <p>({rtl ? `صوم` : fr ? "Le jeûne" : `Fasting`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 plrs">
              <Link to="/five-pillars-zakat">
                <div class="plr-box">
                  <i class="flaticon-charity"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `إيتاءِ الزّكاةِ` : `Zakat`}</h4>
                    <p>({rtl ? `الصدقة` : fr ? "L'aumône" : `Almsgiving`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 ">
              <Link to="/five-pillars-pilgrimage">
                <div class="plr-box">
                  <i class="flaticon-kaaba-building"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `الحجِّ` : `Hajj`}</h4>
                    <p>({rtl ? `حج` : fr ? "Pèlerinage" : `Pilgrimage`})</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Fasting;
